/** The named web faces a brand can pick (X21-RESA-06). Each face is self-hosted from its @fontsource package (OFL): the latin
 *  subset, weights 400, 500 and 600. The @font-face rules load only when a brand chooses that face, so public pages load no
 *  external font host and no face they do not use. The system ids and unknown ids load nothing. */
const FACES: Record<string, () => Promise<unknown>> = {
  inter: () => Promise.all([import("@fontsource/inter/latin-400.css"), import("@fontsource/inter/latin-500.css"), import("@fontsource/inter/latin-600.css")]),
  "dm-sans": () => Promise.all([import("@fontsource/dm-sans/latin-400.css"), import("@fontsource/dm-sans/latin-500.css"), import("@fontsource/dm-sans/latin-600.css")]),
  "space-grotesk": () =>
    Promise.all([import("@fontsource/space-grotesk/latin-400.css"), import("@fontsource/space-grotesk/latin-500.css"), import("@fontsource/space-grotesk/latin-600.css")]),
  "jetbrains-mono": () =>
    Promise.all([import("@fontsource/jetbrains-mono/latin-400.css"), import("@fontsource/jetbrains-mono/latin-500.css"), import("@fontsource/jetbrains-mono/latin-600.css")]),
};

const loaded = new Set<string>();

/** Loads the @font-face rules of a named face once. A failed load is retried the next time the brand is shown. */
export function loadBrandFace(id: string | null | undefined): Promise<void> {
  if (!id || loaded.has(id) || !Object.prototype.hasOwnProperty.call(FACES, id)) return Promise.resolve();
  loaded.add(id);
  return FACES[id]!().then(
    () => undefined,
    () => {
      loaded.delete(id);
    },
  );
}
